<mat-dialog-content>
  <h2 mat-dialog-title>{{ data.title | translate }}</h2>
  <mat-form-field>
    <input
      matInput
      cdkFocusInitial
      [matAutocomplete]="auto"
      [formControl]="formControl"
      [placeholder]="data.placeholder | translate"
    />
    <mat-autocomplete
      #auto="matAutocomplete"
      autoActiveFirstOption
      (optionSelected)="setOption($event)"
    >
      <mat-option
        *ngFor="let option of filteredOptions$ | async"
        [value]="option.name"
      >
        {{ option.name }}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button color="primary" (click)="close(true)">
    {{ 'FRONTEND.LOOP.ACTION_LABELS.SAVE' | translate }}
  </button>
  <button mat-button color="primary" (click)="close(false)">
    {{ 'FRONTEND.LOOP.ACTION_LABELS.CANCEL' | translate }}
  </button>
</mat-dialog-actions>
